import { connect } from 'react-redux'
import withFormFields from 'shared/ui/Form/withFormFields'
import {
  doUpdateFacebookPageSubscriptions,
  selectFacebookPagesAsFormFields,
  selectIsFetchingFacebookPages,
  selectFacebookPages,
} from 'subapps/onboarding/ducks/facebook'
import FacebookPageSelectionPage from './view'
import { CHANNEL_OVERVIEW_PAGE } from '../pages'

const select = state => {
  return {
    availablePages: selectFacebookPages(state),
    initialValues: selectFacebookPagesAsFormFields(state),
    fetching: selectIsFetchingFacebookPages(state),
  }
}

const perform = dispatch => {
  return {
    onSave: subscriptions =>
      dispatch(doUpdateFacebookPageSubscriptions(subscriptions)),
    doCancel: () => dispatch({ type: CHANNEL_OVERVIEW_PAGE }),
  }
}

export default connect(select, perform)(
  withFormFields(FacebookPageSelectionPage)
)
